// Blitzcrank — Rocket Grab: rotates the enemy formation — the backmost enemy is
// yanked to the front (slot 0) while all others shift back one slot.

import type { Ability, AbilityHit } from "./Ability";

export const blitzcrankHook: Ability = {
  id: "blitzcrankHook",
  displayName: "Rocket Grab",
  description: "Yanks the backmost enemy to the front and shifts the rest of the enemy team back.",
  iconId: "RocketGrab",

  targetShape({ caster, combat }) {
    const team = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(team).map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const team = caster.team === "player" ? "enemy" : "player";
    const sorted = combat.livingUnitsOf(team).sort((a, b) => a.pos.q - b.pos.q);
    if (sorted.length < 2) return [];

    const row = sorted[0].pos.r;
    const backmost = sorted[sorted.length - 1];
    const rest = sorted.slice(0, -1);
    const hits: AbilityHit[] = [];

    // Shift the front enemies back first (in reverse order to avoid conflicts)
    for (let i = rest.length - 1; i >= 0; i--) {
      hits.push({
        target: rest[i], amount: 0, type: "none",
        effect: { kind: "teleport", hex: { q: i + 1, r: row } },
      });
    }
    // Pull backmost to slot 0
    hits.push({
      target: backmost, amount: 0, type: "none",
      effect: { kind: "teleport", hex: { q: 0, r: row } },
      hookPass: true,
    });
    return hits;
  },
};
